module.exports = __webpack_public_path__ + "static/media/checked.8ef11a58.svg";